import { createClient } from '@supabase/supabase-js';

// Read from Vite env if present; fall back to hardcoded values for development
const supabaseUrl = import.meta?.env?.VITE_SUPABASE_URL || 'https://evpyevpvdhbypvciyjxi.supabase.co';
const supabaseAnonKey = import.meta?.env?.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImV2cHlldnB2ZGhieXB2Y2l5anhpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTc0MDgwOTUsImV4cCI6MjA3Mjk4NDA5NX0.2Lq2nBzSfsCCFgPgxyQR4k3wP6GhSdUUg8lsABH2Dlw';

// Validate required values
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Supabase configuration missing. Please check your environment variables.');
  throw new Error('Supabase configuration is required');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
});

export default supabase;


